import type { ActionList } from './ActionSelect';
import { getEnvConfig } from '@configs/env';
import { ProviderIcon } from '@configs/providerIcons';
import styled from '@emotion/styled';
import { Avatar } from '@mui/material';
import { fonts } from '@theme/fontsCustomer';

interface Props {
  action: ActionList;
}
export const InnerAction = ({ action }: Props) => {
  const { SMP_PROVIDER_NAME } = getEnvConfig();
  const isSMPAppAction = action.id === String(SMP_PROVIDER_NAME);

  return (
    <InnerActionContainer>
      <ActionIcon>
        {isSMPAppAction ? (
          <ProviderIcon providerName={action.id} variant="main" width={36} height={36} />
        ) : (
          <Avatar src={action.iconUrl} sx={{ width: '36px', height: '36px' }} variant="square" />
        )}
      </ActionIcon>
      <ActionInfo>
        <ActionName>{action.appName}</ActionName>
        {action.subscriptionName && <ActionDescription>{action.subscriptionName}</ActionDescription>}
      </ActionInfo>
    </InnerActionContainer>
  );
};

const InnerActionContainer = styled.div<{ isSelected?: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap: 16px;
`;

const ActionIcon = styled.span`
  display: flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
`;

const ActionInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const ActionName = styled.strong`
  ${fonts.Headline8};
  color: ${({ theme: { colors } }) => colors['text-gray-main']};
  transition: color 0.2s;
`;

const ActionDescription = styled.p`
  ${fonts.Body2};
  color: ${({ theme: { colors } }) => colors['text-gray-sub-dark']};
  transition: color 0.2s;
  margin: 0;
`;
